module.exports = __webpack_public_path__ + "img/photo_antonin_winterstein.2b2ad7eb.jpg";